// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"320c981b","453":"7ad3a4d4","732":"d07f7e43","977":"7230c8e4"}[chunkId] + ".chunk.js";
};